import { Component, Input, Output, EventEmitter, ViewChild, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { CedidoInvoiceDTO } from '../../interfaces/company-cesionario.interface';
import { ChangePaginationEvent, ChangeSortingEvent } from 'src/app/common/interfaces/paged-result.interface';

@Component({
  selector: 'app-cedido-invoices-table',
  templateUrl: './cedido-invoices-table.component.html',
  styleUrls: ['./cedido-invoices-table.component.scss']
})
export class CedidoInvoicesTableComponent implements OnInit{

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  public dataSource: MatTableDataSource<CedidoInvoiceDTO>;
  public columns = [
    'folio',
    'fechaDocto',
    'montoTotal',
    'fechaCesion',
    'montoCesion',
    'proveedorRut',
    'proveedorName',
    'clienteRut',
    'clienteName',
    'cesionarioRut',
    'cesionarioName'
  ];

  @Input() cedidos: Array<CedidoInvoiceDTO>;
  @Input() totalRows: number;
  @Input() page: number;
  @Input() pageSize: number;
  @Input() sortColumn: string;
  @Input() sortDirection: string;
  @Output() paginationChange = new EventEmitter<ChangePaginationEvent>;
  @Output() sortingChange = new EventEmitter<ChangeSortingEvent>;

  constructor() {
    this.dataSource = new MatTableDataSource([]);
  }

  ngOnInit(): void {
    this.setDataSource();
    this.setSorting();
  }

  public setDataSource(){
    this.dataSource.data = this.cedidos;
    this.paginator.pageIndex = this.page - 1
    this.paginator.pageSize = this.pageSize;
    this.paginator.length = this.totalRows;
  }

  public setSorting(){
    this.sort.active = this.sortColumn;
    if(this.sortDirection){
      this.sort.direction = this.sortDirection === 'asc' ? 'asc' : 'desc';
    }
  }

  changePagination(pageEvent: PageEvent) {
    const changePagination: ChangePaginationEvent = {
      page: pageEvent.pageIndex + 1,
      pageSize: pageEvent.pageSize
    };
    this.paginationChange.emit(changePagination);
  }

  changeSorting(sort: Sort) {
    const sortEvent: ChangeSortingEvent = {
      sortColumn: sort.active,
      sortDirection: sort.direction.toLowerCase()
    };
    this.sortingChange.emit(sortEvent)
  }


}
